'use client';

import { CircleAlert, CircleCheck, CircleMinus, Info } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      {...props}
      icons={{
        success: <CircleCheck size={16} className="stroke-2! text-green-500 dark:text-green-400" />,
        error: <CircleMinus size={16} className="stroke-2! text-red-500 dark:text-red-400" />,
        warning: (
          <CircleAlert size={16} className="stroke-2! text-orange-500 dark:text-orange-400" />
        ),
        info: <Info size={16} className="stroke-2! text-blue-500 dark:text-blue-400" />,
      }}
      duration={5000}
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            'flex gap-2 rounded-[20px] py-5 sm:py-6 pl-4 pr-5 sm:pr-11 items-center min-w-[270px]',
          error: 'bg-red-100 border border-red-500 dark:bg-grey-1100 dark:border-red-400',
          success: 'bg-green-100 border border-green-500 dark:bg-grey-1100 dark:border-green-400',
          warning:
            'bg-orange-100 border border-orange-500 dark:bg-grey-1100 dark:border-orange-400',
          info: 'bg-grey-50 border border-blue-600 dark:bg-grey-1100 dark:border-blue-400',
          title: 'font-normal text-primary dark:text-neutral-100 text-xs sm:text-sm leading-5',
          description: 'text-sm opacity-90',
        },
      }}
    />
  );
};

export { Toaster };
